/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_TitleInputs */

const en_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start With Setup`)
};

const es_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza con el setup`)
};

const de_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnen Sie mit der Ansprechposition`)
};

const zh_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从站位准备开始`)
};

const ar_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابدأ بالإعداد`)
};

const fr_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commencez par la mise en place`)
};

const vi_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu với setup`)
};

const sw_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anza na Maandalizi`)
};

const th_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มจากท่าเตรียม`)
};

const bs_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počni sa setupom`)
};

const ja_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セットアップから始める`)
};

const ko_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`셋업부터 시작하기`)
};

const pt_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece pela preparação`)
};

const it_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parti dal setup`)
};

const sv_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja med uppställningen`)
};

const nl_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met de opstelling`)
};

const da_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start med opstillingen`)
};

const nb_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start med oppstillingen`)
};

const fi_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita lähtöasennosta`)
};

const pl_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij od ustawienia`)
};

const ru_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начните с исходной позиции`)
};

const tr_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hazırlıkla başlayın`)
};

const hi_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेटअप से शुरू करें`)
};

const id_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari Setup`)
};

const ms_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan dengan Persediaan`)
};

const cs_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začněte postavením`)
};

const el_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ξεκινήστε από την προετοιμασία`)
};

const he_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחילו מעמידת הפתיחה`)
};

const af_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met die opstelling`)
};

const hu_method_content_step_01_title = /** @type {(inputs: Method_Content_Step_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdd az alapállással`)
};

/**
* | output |
* | --- |
* | "Start With Setup" |
*
* @param {Method_Content_Step_01_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_title = /** @type {((inputs?: Method_Content_Step_01_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_title(inputs)
	if (locale === "de") return de_method_content_step_01_title(inputs)
	if (locale === "zh") return zh_method_content_step_01_title(inputs)
	if (locale === "ar") return ar_method_content_step_01_title(inputs)
	if (locale === "fr") return fr_method_content_step_01_title(inputs)
	if (locale === "vi") return vi_method_content_step_01_title(inputs)
	if (locale === "sw") return sw_method_content_step_01_title(inputs)
	if (locale === "th") return th_method_content_step_01_title(inputs)
	if (locale === "bs") return bs_method_content_step_01_title(inputs)
	if (locale === "ja") return ja_method_content_step_01_title(inputs)
	if (locale === "ko") return ko_method_content_step_01_title(inputs)
	if (locale === "pt") return pt_method_content_step_01_title(inputs)
	if (locale === "it") return it_method_content_step_01_title(inputs)
	if (locale === "sv") return sv_method_content_step_01_title(inputs)
	if (locale === "nl") return nl_method_content_step_01_title(inputs)
	if (locale === "da") return da_method_content_step_01_title(inputs)
	if (locale === "nb") return nb_method_content_step_01_title(inputs)
	if (locale === "fi") return fi_method_content_step_01_title(inputs)
	if (locale === "pl") return pl_method_content_step_01_title(inputs)
	if (locale === "ru") return ru_method_content_step_01_title(inputs)
	if (locale === "tr") return tr_method_content_step_01_title(inputs)
	if (locale === "hi") return hi_method_content_step_01_title(inputs)
	if (locale === "id") return id_method_content_step_01_title(inputs)
	if (locale === "ms") return ms_method_content_step_01_title(inputs)
	if (locale === "cs") return cs_method_content_step_01_title(inputs)
	if (locale === "el") return el_method_content_step_01_title(inputs)
	if (locale === "he") return he_method_content_step_01_title(inputs)
	if (locale === "af") return af_method_content_step_01_title(inputs)
	if (locale === "hu") return hu_method_content_step_01_title(inputs)
	return en_method_content_step_01_title(inputs)
});